import {ServiceEventEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ServiceEventAction} from "./ServiceEventActionMenu";
import {useServiceEventMutation} from "../../../hooks/useServiceEventMutation";

export type UseServiceEventActionProps = {}

export type UseServiceEventActionResult = {
  onServiceEventActionClick: (serviceEvent: ServiceEventEntity, action: ServiceEventAction) => void;
}

export const useServiceEventAction = (props: UseServiceEventActionProps = {}): UseServiceEventActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteServiceEvent,
  } = useServiceEventMutation()

  const _onServiceEventActionClick = useCallback((serviceEvent: ServiceEventEntity, action: ServiceEventAction) => {
    if (action === "EDIT") {
      navigate(`/service-events/form`, {state: {id: serviceEvent.id}})
    } else if (action === "DELETE") {
      deleteServiceEvent(serviceEvent.id, undefined)
    }
  }, [navigate, deleteServiceEvent])

  return {
    onServiceEventActionClick: _onServiceEventActionClick
  }
}
